/**
 * Possible date formats that our formatter supports.
 *
 * These are copied from the monolith's `inc/locale.php`
 */
export const DateFormat = {
	/**
	 * Examples:
	 * - Current year: "Fri, 03.12"
	 * - Not current year: "Fri, 03.12.2012"
	 */
	DATE_SHORT_NO_CURRENT_YEAR: 'date_short_no_current_year',

	/**
	 * Examples:
	 * - "03.12.2012"
	 */
	DATE: 'date',

	/**
	 * Examples:
	 * - "03.12.2012 09:57"
	 */
	DATE_TIME_FULL: 'date_time_full',

	/**
	 * Examples:
	 * - "03.12.2012 09:57"
	 * - "Today 09:57"
	 * - "Yesterday 09:57"
	 */
	DATE_RELATIVE_TO_TODAY_WITH_TIME: 'date_relative_to_today_with_time',

	/**
	 * Examples:
	 * - "March"
	 * - "December"
	 */
	ONLY_MONTH_AS_WORD: 'only_month_as_word',

	/**
	 * Examples:
	 * - "23"
	 */
	ONLY_DAY_NUMBER: 'only_day_number',

	/**
	 * Examples:
	 * - "2022"
	 */
	ONLY_YEAR_NUMBER: 'only_year_number',

	/**
	 * Examples:
	 * - "02" - 2nd week of the year
	 * - "52" - 52nd week of the year
	 */
	ONLY_WEEK_OF_YEAR: 'only_week_of_year',

	/**
	 * Examples:
	 * - "16.05" (current year)
	 * - "16.05.2021" (last year)
	 */
	DATE_NO_CURRENT_YEAR: 'date_no_current_year',

	/**
	 * Examples:
	 * - "Mar" (current year)
	 * - "Mar 2021" (last year)
	 */
	MONTH_SHORT_NO_CURRENT_YEAR: 'month_short_no_current_year',

	/**
	 * Examples:
	 * - "Fri 01.07"
	 */
	WEEKDAY_SHORT_DAY_MONTH: 'weekday_short_day_month',

	/**
	 * Examples:
	 * - "F 01.07"
	 */
	WEEKDAY_NARROW_DAY_MONTH: 'weekday_narrow_day_month',

	/**
	 * Examples:
	 * - "01.07"
	 */
	DATE_DAY_MONTH: 'date_day_month',
} as const;
